import { useState, useEffect } from 'react'
import { useQuery } from '@apollo/client'

import gql from 'graphql-tag'

const QUERY = gql`
query PromotionalPages($skip: Int, $limit: Int, $where: PromotionalPageFilter) {
    promotionalPageCollection(
      limit: $limit,
      skip: $skip,
      where: $where
      order: headline_ASC,
    ) {
      total
      items {
        __typename
        sys {
          id
        }
        eventCategory {
          name
        }
        headline
        summary
        slug
        image {
          url
        }
        imageWithFocalPoint {
          image {
            url
            width
            height
          }
          focalPoint
        }
        ctaText
      }
    }
}
`

const usePagination = (isMobile, limit, categories) => {
  const [skip, setSkip] = useState(0)

  const defaultQuery = categories.reduce((prev, curr) => {
    prev.push({ eventCategory: { sys: { id: curr.sys.id } } })
    return prev
  }, [])

  const [where, setWhere] = useState({ AND: [{ OR: defaultQuery }] })
  const {
    data, loading, fetchMore,
  } = useQuery(QUERY, {
    variables: {
      limit,
      skip,
      where,
    },
    notifyOnNetworkStatusChange: true,
  })

  const paginateDesktop = (newOffset) => {
    setSkip(newOffset)
  }

  const paginateMobile = () => {
    fetchMore({
      variables: {
        skip: data.promotionalPageCollection.items.length,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev
        const { promotionalPageCollection } = fetchMoreResult
        return ({
          promotionalPageCollection: {
            items: [
              ...prev.promotionalPageCollection.items,
              ...promotionalPageCollection.items,
            ],
            total: promotionalPageCollection.total,
            __typename: promotionalPageCollection.__typename,
          },
        })
      },
    })
  }

  useEffect(() => {
    setSkip(0)
  }, [isMobile])

  const handlePagination = (newOffset) => {
    if (isMobile) {
      paginateMobile()
    } else {
      paginateDesktop(newOffset)
    }
  }

  const handleCategoryChange = (newCategory) => {
    if (newCategory === '') {
      setWhere({ AND: [{ OR: defaultQuery }] })
    } else {
      setWhere({ AND: [{ eventCategory: { sys: { id: newCategory } } }] })
    }
  }

  return [
    data, loading, handlePagination,
    handleCategoryChange,
    skip,
  ]
}

export default usePagination
